<template>
  <section class="bg-gradient-to-br from-gray-50 to-white min-h-full">
    <div class="max-w-4xl mx-auto p-4 md:p-6">
      <!-- Introduction -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="mb-4">
          <h1 class="font-trebuchet-pixel text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {{ $t('windows.documents.about.title') }}
          </h1>
          <div class="h-1 w-20 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full mb-4"></div>
        </div>
        
        <p class="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
          {{ $t('windows.documents.about.introduction') }}
        </p>
      </div>

      <!-- Objectifs Court Terme -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="flex items-center gap-3 mb-4">
          <div class="p-2 bg-blue-100 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-blue-600">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <h2 class="font-trebuchet-pixel text-lg md:text-xl font-semibold text-gray-900">
            {{ $t('windows.documents.about.shortTermTitle') }}
          </h2>
        </div>
        <div class="ml-11">
          <p class="text-sm md:text-base text-gray-700 leading-relaxed">
            {{ $t('windows.documents.about.shortTermContent') }}
          </p>
        </div>
      </div>

      <!-- Objectifs Moyen Terme -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="flex items-center gap-3 mb-4">
          <div class="p-2 bg-indigo-100 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-indigo-600">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <h2 class="font-trebuchet-pixel text-lg md:text-xl font-semibold text-gray-900">
            {{ $t('windows.documents.about.mediumTermTitle') }}
          </h2>
        </div>
        <div class="ml-11">
          <p class="text-sm md:text-base text-gray-700 leading-relaxed">
            {{ $t('windows.documents.about.mediumTermContent') }}
          </p>
        </div>
      </div>

      <!-- Objectifs Long Terme -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="flex items-center gap-3 mb-4">
          <div class="p-2 bg-purple-100 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-purple-600">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <path d="M22 4L12 14.01l-3-3" />
            </svg>
          </div>
          <h2 class="font-trebuchet-pixel text-lg md:text-xl font-semibold text-gray-900">
            {{ $t('windows.documents.about.longTermTitle') }}
          </h2>
        </div>
        <div class="ml-11">
          <p class="text-sm md:text-base text-gray-700 leading-relaxed">
            {{ $t('windows.documents.about.longTermContent') }}
          </p>
        </div>
      </div>

      <!-- Inspiration -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="flex items-center gap-3 mb-4">
          <div class="p-2 bg-green-100 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-green-600">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <h2 class="font-trebuchet-pixel text-lg md:text-xl font-semibold text-gray-900">
            {{ $t('windows.documents.about.inspirationTitle') }}
          </h2>
        </div>
        <div class="ml-11">
          <p class="text-sm md:text-base text-gray-700 leading-relaxed">
            {{ $t('windows.documents.about.inspirationContent') }}
          </p>
        </div>
      </div>

      <!-- Réflexion sur le parcours -->
      <div class="bg-white rounded-xl p-5 md:p-6 shadow-lg border border-gray-100 mb-5">
        <div class="flex items-center gap-3 mb-4">
          <div class="p-2 bg-indigo-100 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-indigo-600">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h2 class="font-trebuchet-pixel text-lg md:text-xl font-semibold text-gray-900">
            {{ $t('windows.documents.about.reflectionTitle') }}
          </h2>
        </div>
        <div class="ml-11">
          <p class="text-sm md:text-base text-gray-700 leading-relaxed">
            {{ $t('windows.documents.about.reflectionContent') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
